import { render } from "./MultiPointCalibrationProfileIndex.vue?vue&type=template&id=01089d22"
import script from "./MultiPointCalibrationProfileIndex.vue?vue&type=script&lang=js"
export * from "./MultiPointCalibrationProfileIndex.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__